export default "__VITE_ASSET__BpkInULu__"